<template>
  <div>
    <v-card flat>
    <v-card-title>
      <v-spacer></v-spacer> <v-btn color="orange" depressed rounded x-large @click="send" dark>Send
      </v-btn>
    </v-card-title>

    <iframe allow="*" ref="printPage" style="width: 100%; height: 70vh; border:none; background-color: #ffffff; overflow: auto;"
            :src="$store.state.printURL">
    </iframe>
    <v-card-actions v-if="$vuetify.breakpoint.mobile">
      <v-btn @click="print" color="green" dark block rounded x-large depressed>Print
        <v-icon>mdi-printer</v-icon>
      </v-btn>
    </v-card-actions>

    <v-card-actions>
      <v-btn color="error" x-large @click="$store.state.showPrint=false" dark depressed block rounded>Close</v-btn>
    </v-card-actions>
    <v-dialog v-model="sendDialog" :persistent="sending" width="400">
      <v-card>
        <v-card-title
          >Send receipt <v-spacer></v-spacer
          ><v-btn
            :disabled="sending"
            color="red"
            icon
            @click="sendDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          ></v-card-title
        >
        <v-card-subtitle class="pt-0 pb-4" style="color: #888">
          Choose how you'd like to send the receipt to your customer
        </v-card-subtitle>
        <v-card-text>
          <div class="mb-4">
            <div class="font-weight-bold mb-2">Delivery Method</div>
            <div style="display: flex; gap: 20px; margin-bottom: 24px">
              <v-btn
                v-for="method in filteredDeliveryMethods"
                :key="method.value"
                :outlined="deliveryMethod !== method.value"
                :color="
                  deliveryMethod === method.value ? 'orange lighten-5' : ''
                "
                :class="[
                  'elevation-0',
                  'pa-8',
                  'flex-grow-1',
                  deliveryMethod === method.value
                    ? 'delivery-selected'
                    : 'delivery-unselected',
                ]"
                style="
                  flex-direction: column;
                  border-width: 1px;
                  border-radius: 12px;
                  min-width: 120px;
                  min-height: 100px;
                "
                @click="deliveryMethod = method.value"
              >
                <v-icon size="32" class="mb-2 mr-2">{{ method.icon }}</v-icon>
                <span class="font-weight-medium" style="font-size: 1.1rem">{{
                  method.label
                }}</span>
              </v-btn>
            </div>
            <v-divider class="mb-4"></v-divider>
            <div class="font-weight-bold mb-2">
              {{ selectedDeliveryMethod.inputLabel }}
            </div>
            <v-form ref="sendForm">
              <v-text-field
                v-if="deliveryMethod"
                :value="deliveryMethod === 'email' ? email : phone"
                @input="
                  deliveryMethod === 'email'
                    ? (email = $event)
                    : (phone = $event)
                "
                :rules="
                  deliveryMethod === 'email'
                    ? [rules.required, rules.email]
                    : [rules.required, rules.phone]
                "
                persistent-hint
                color="orange"
                :label="selectedDeliveryMethod.placeholder"
                outlined
                :type="selectedDeliveryMethod.type"
              ></v-text-field>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="sending"
            block
            color="orange"
            dark
            depressed
            rounded
            x-large
            @click="sendReciept"
            >Send</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="success" color="green" dark>{{ message }}</v-snackbar>
    <v-snackbar v-model="error" color="error" dark>{{
      error_message
    }}</v-snackbar>
  </v-card>
  </div>
</template>

<script>

export default {
  props: ["url"],
  name: "printDialogComponent",
  data() {
    return {
      rules: {
        required: (value) => !!value || "Required",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        phone: (value) => {
          const digits = value.replace(/\D/g, "");
          return digits.length >= 10 || "Invalid phone number.";
        },
      },
      error: false,
      error_message: "",
      message: "",
      success: false,
      sendDialog: false,
      sending: false,
      deliveryMethod: "email",
      email: "",
      phone: "",
      deliveryMethods: [
        { value: "email", label: "Email", icon: "mdi-email", placeholder: "Email", type: "email" },
        { value: "sms", label: "SMS", icon: "mdi-message", placeholder: "Phone Number", type: "tel" },
      ],
    };
  },
  computed: {
    filteredDeliveryMethods() {
      return this.deliveryMethods.filter(
        (method) => method.value !== "sms" || this.CAN_SEND_SMS_RECEIPTS
      );
    },
    CAN_SEND_SMS_RECEIPTS() {
      return this.$store.state.user.current_business.country_id === 81;
    },
    selectedDeliveryMethod() {
      return (
        this.deliveryMethods.find((m) => m.value === this.deliveryMethod) ||
        this.deliveryMethods[0]
      );
    },
    itemID() {
      return this.$store.state.saleItemID;
    },
  },
  methods: {
    sendReciept() {
      console.log(this.$store.state.saleItemID);
      if (this.deliveryMethod === "email") {
        if (this.$refs.sendForm.validate()) {
          this.sending = true;

          window.axios
            .post("/api/sendreciept/" + this.itemID, {
              email: this.email,
            })
            .then(() => {
              this.message = "Receipt sent successfully";
              this.success = true;
              this.sendDialog = false;
              this.email = "";
            })
            .finally(() => {
              this.sending = false;
            });
        }
      } else if (this.deliveryMethod === "sms") {
        if (this.$refs.sendForm.validate()) {
          this.sending = true;
          window.axios
            .post(`/api/sendreciept-sms/${this.itemID}`, {
              recipient_number: this.phone,
            })
            .then(() => {
              this.message = "Receipt sent successfully";
              this.success = true;
              this.sendDialog = false;
              this.phone = "";
            })
            .finally(() => {
              this.sending = false;
            });
        }
      }
    },
    print() {
    },
    send() {
      this.sendDialog = true;
    }
  }
}
</script>

<style scoped>
.delivery-selected {
  border: 1px solid #222 !important;
  background: #fff !important;
  color: #222 !important;
}
.delivery-unselected {
  border: 1px solid #eee !important;
  background: #fafafa !important;
}
</style>